import { StandardLonghandProperties } from 'csstype';
import React, { forwardRef } from 'react';
import { OmitStrict } from '@tanium/coreui-utils';
import { FormInput, FormInputProps } from '@tanium/react-form-input';
import { Select, SelectProps, SelectType } from '@tanium/react-select';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface Props<TFields = any, K extends keyof TFields = any, ObjectType = any>
  extends OmitStrict<FormInputProps<TFields, K>, 'children'>,
    SelectProps<ObjectType> {
  width?: StandardLonghandProperties<string | number>['width'];
}

export const FormSelectInput = forwardRef<SelectType, Props>(
  ({ dataKey, width = 400, ...rest }, ref) => (
    <FormInput dataKey={dataKey}>
      {({ idForInput, hasErrors, onChange, value = '' }) => (
        // eslint-disable-next-line react-perf/jsx-no-new-object-as-prop -- object references parameter passed to inner function
        <div style={{ width }}>
          <Select
            ref={ref}
            invalid={hasErrors}
            inputId={idForInput}
            value={value}
            // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- function depends on parameter passed to inner function
            onChange={(newValue) => {
              onChange({ value: newValue });
            }}
            {...rest}
          />
        </div>
      )}
    </FormInput>
  ),
);
